/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityVulnerabilityValidationForGCPResponse {
    getFixupPrototypeFunction() { return SecurityVulnerabilityValidationForGCPResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityVulnerabilityValidationForGCPResponse>): SecurityVulnerabilityValidationForGCPResponse {
        let obj = Object.assign(new SecurityVulnerabilityValidationForGCPResponse(), model);
        SecurityVulnerabilityValidationForGCPResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityVulnerabilityValidationForGCPResponse>): SecurityVulnerabilityValidationForGCPResponse {
        if (!model) return null;
        return SecurityVulnerabilityValidationForGCPResponse.newInstance(<SecurityVulnerabilityValidationForGCPResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityVulnerabilityValidationForGCPResponse) {
        if (!obj) return;

        models.SecurityVulnerabilityValidationForGCPResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityVulnerabilityValidationForGCPResponse): boolean {
        Object.setPrototypeOf(obj, SecurityVulnerabilityValidationForGCPResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * If set, Web Security Scanner is enabled.
     */
    web_security_scanner: boolean;

    /**
     * If set, Security Health Analytics is enabled.
     */
    security_health_analytics: boolean;

}
